<template>
    <div style="width:100%;">

        <nav>

            <v-app-bar color="indigo" dark fixed app>
                <v-app-bar-nav-icon class="grey--text" @click="drawer = !drawer"></v-app-bar-nav-icon>
                <v-toolbar-title class="text-uppercase grey--text">
                    <span class="font-weight-light">DIAGNOSTICS</span>
                </v-toolbar-title>
                <v-spacer></v-spacer>


                <v-btn  text color="grey"
                    @click.prevent="addDoc()">
                    <v-icon right>add_box</v-icon>
                </v-btn>

                <v-btn  text color="grey"
                    @click.prevent="refresh()">
                    <v-icon right>refresh</v-icon>
                </v-btn>

                <v-btn text color="grey"
                    @click.prevent="signOut">
                    <span></span>
                    <v-icon right>exit_to_app</v-icon>
                </v-btn>

            </v-app-bar> 

            <NavDraw :drawer="drawer" ></NavDraw>

        </nav>
        <v-container>

            <div>

                <v-layout column>
                    <v-flex>
                        <v-layout row class="row-header">
                            <v-flex xs5 md6 class="col-header">Diagnostic</v-flex>
                            <v-flex xs4 md4 class="col-header">Diagnostic Type</v-flex>
							<v-flex xs1 md1 class="col-header">Idx</v-flex>
                            <v-flex xs2 md1 v-if="updateMode != ''" class="col-header"></v-flex>

                        </v-layout>
                    </v-flex>
                    <v-flex>
                        <v-layout v-if="updateMode == 'add'" row>
                            <v-flex xs5 md6>
                                <v-text-field  class="mr-2"
                                    v-model="newDoc.diagnostic"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs4 md4>
                                <v-select  class="mr-2"
                                    :items="diagnosticTypes"
                                    item-text="diagnosticType"
                                    v-model="newDoc.diagnosticType"
                                >
                                    <template slot='item' slot-scope='{ item }'>
                                        {{ item.diagnosticType }}
                                    </template>

                                </v-select>                                                       
                            </v-flex>
                            <v-flex xs1 md1>
                                <v-text-field
                                    v-model="newDoc.idx"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs2 md2>
                                <v-layout row>
                                    <v-flex shrink>
                                        <v-btn dark small color="pink" fab  class="mr-2"
                                            @click.prevent="saveAdd()">
                                            <v-icon>save</v-icon>
                                        </v-btn>

                                    </v-flex>
                                    <v-flex shrink>
                                        <v-btn dark small color="pink" fab  
                                            @click.prevent="cancelAdd()">
                                            <v-icon>undo</v-icon>
                                        </v-btn>

                                    </v-flex>
                                </v-layout>


                            </v-flex>

                        </v-layout>

                    </v-flex>
                    <v-flex v-for="(doc,i) in docs" :key="i">

                        <v-layout v-if="updateMode == 'edit' && doc.active" row>
                            <v-flex xs5 md6>
                                <v-text-field class="mr-2"
                                    v-model="activeDoc.diagnostic"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs4 md4>
                                <v-select  class="mr-2"
                                    :items="diagnosticTypes"
                                    item-text="diagnosticType"
                                    v-model="activeDoc.diagnosticType"
                                >
                                    <template slot='item' slot-scope='{ item }'>
                                        {{ item.diagnosticType }}
                                    </template>

                                </v-select>                                                       
                            </v-flex>
                            <v-flex xs1 md1>
                                <v-text-field
                                    v-model="activeDoc.idx"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs2 md1>
                                <v-layout row>
                                    <v-flex shrink>
                                        <v-btn dark small color="pink" fab  class="mr-2"
                                            @click.prevent="saveUpdate(doc)">
                                            <v-icon>save</v-icon>
                                        </v-btn>

                                    </v-flex>
                                    <v-flex shrink>
                                        <v-btn dark small color="pink" fab  
                                            @click.prevent="cancelUpdate(doc)">
                                            <v-icon>undo</v-icon>
                                        </v-btn>

                                    </v-flex>
                                </v-layout>


                            </v-flex>

                        </v-layout>

                        <v-layout v-else row>
                            <v-flex xs5 md6 class="doc-key" @click="setUpdateMode(doc)">
                                {{ doc.diagnostic }}
                            </v-flex>
                            <v-flex xs4 md4>
                                {{ doc.diagnosticType }}
                            </v-flex>
                            <v-flex xs1 md1>
                                {{ doc.idx }}
                            </v-flex>
                            <v-flex xs2 md1 v-if="updateMode == 'edit'"></v-flex>
                        </v-layout>

                    </v-flex>

                </v-layout>

            </div>

        </v-container>
        <v-overlay :value="overlay">
        <v-progress-circular
            indeterminate
            color="purple"
            size="200"
        ></v-progress-circular>
        </v-overlay>

    </div>
</template>

<script>
import NavDraw from '@/components/NavDraw'
import {mapState, mapActions} from 'vuex'
//import DocFileDetail from './DocFileDetail'

const fb = require('../../firebaseConfig.js')

export default {
    components:{NavDraw},
    data(){
        return {
            drawer:false,
            docs:[],
            activeDoc:null,
            updateMode:'',
            newDoc:{
                diagnostic:'',
                diagnosticType:'',
                idx:0
            },
            overlay:false
        }
    },
    computed:{
        ...mapState(['diagnostics','diagnosticTypes','currentUser'])
    },
    methods:{
        ...mapActions(['fetchDiagnostics','setCurrentUser']),
        refresh(){
            //this.$store.dispatch('VIDEOS_GET');

            if (this.drawer){
                this.drawer = false
            }

            this.updateMode = ''

            this.setDocs()
            
        },
        addDoc(){
           
            if (this.drawer){
                this.drawer = false
            }

            if (this.updateMode != ''){
                return
            }

            this.updateMode = 'add'

        },
        cancelAdd(){
            this.updateMode = ''
            this.newDoc = {
                diagnostic:'',
                diagnosticType:'',
                idx:0
            }
        },
        saveAdd(){

            fb.diagnosticsCollection.add({
                diagnostic : this.newDoc.diagnostic,
                hdType:this.currentUser.hdType,
                idx: this.newDoc.idx,
                diagnosticType:this.newDoc.diagnosticType,
                creationDate: new Date(),
            })
            .then((docRef)=>{
                console.log("docRef ", docRef);
                if (docRef){
                    this.$store.state.diagnostics.push({
                        id:docRef.id,
                        diagnostic:this.newDoc.diagnostic,
                        diagnosticType:this.newDoc.diagnosticType,
                        hdType:this.currentUser.hdType,
                        idx:this.newDoc.idx,
                        creationDate:new Date()
                    })
                    this.docs.push({
                        id:docRef.id,
                        diagnostic:this.newDoc.diagnostic,
                        diagnosticType:this.newDoc.diagnosticType,
                        hdType:this.currentUser.hdType,
                        idx:this.newDoc.idx,
                        creationDate:new Date()
                    })
                }
                this.updateMode = ''
            })
            .catch(error=>console.log(error))

        },
        setUpdateMode(doc){

            if (this.drawer){
                this.drawer = false
            }

            if (this.updateMode != ''){
                return
            }
            this.updateMode = 'edit'
            doc.active = true
            this.activeDoc = {...doc}
        },
        cancelUpdate(doc){
            doc.active = false
            this.updateMode = ''
        },
        saveUpdate(doc){

            fb.diagnosticsCollection.doc(doc.id).update({
                diagnostic : this.activeDoc.diagnostic,
                idx: this.activeDoc.idx,
                diagnosticType:this.activeDoc.diagnosticType
            })

            doc.diagnostic = this.activeDoc.diagnostic
            doc.diagnosticType = this.activeDoc.diagnosticType
            doc.idx = this.activeDoc.idx

            this.updateMode = ''

        },
        signOut(){

            let self = this;
            fb.auth.signOut().then(function() {
                self.$router.push({name:'Login'})
            }).catch(function(error) {
                // An error happened.
                console.log(error.message)
            });

        },
        setDocs(){

            this.overlay = true
            let diagnostics = []
            fb.diagnosticsCollection.where("hdType","==",this.currentUser.hdType).get()
            .then(docs=>{
                docs.forEach(doc=>{
                    const  diagnostic = {
                        diagnostic:doc.data().diagnostic,
                        diagnosticType: doc.data().diagnosticType,
                        hdType:doc.data().hdType
                    }
                    diagnostic.idx =  doc.data().idx ? doc.data().idx : '1'
                    diagnostic.creationDate = doc.data().creationDate ? doc.data().creationDate : new Date()
                    diagnostics.push(diagnostic);
                });
                diagnostics.sort((a,b)=>(a.diagnostic > b.diagnostic) ? 1 : -1);
                this.$store.state.diagnostics = [...diagnostics]
                this.docs = [...diagnostics]
                this.docs.forEach(doc=>{
                    doc.active = false
                })
                this.overlay = false
            })
            
        }

    },
    mounted(){

        console.log("Solutions mounted!");

    },
    created(){
        console.log("Diagnostics Created")

        if ( !this.$store.state.currentUser || this.$store.state.currentUser.userID == ''){

            let currentUser = JSON.parse(localStorage.getItem('currentUser'))

            if (currentUser){
                this.setCurrentUser(currentUser)
            }else{
                this.$router.push('/')
            }
            
        }

        this.updateMode = '';

        if (this.$store.state.diagnostics.length == 0){
            this.setDocs()
        }
        else{
            this.docs = [...this.$store.state.diagnostics]

            this.docs.forEach(doc=>{
                doc.active = false
            })
            
        }

    },

}
</script>

<style  scoped>
.doc-key{
    cursor: pointer;
}
.row-header .col-header {
    background-color:black;
    color:white;
    font-weight: bold;
    text-align: center;
    padding-bottom: 5px;
    padding-top: 5px;
    margin-top: 10px;
    margin-bottom: 5px;
}

.row-header .col-header2 {
    background-color:lightgray;
    color:black;
    font-weight: bold;
    font-size:medium;
    text-align: center;
}

.file-icon{
    width:40px;
    height: 40px;
    max-width: 40px;
    max-height: 40px;
}

.dv-clear{
    cursor: pointer;
}
.label-text{
    font-weight: bold;
}
.dv-message{
    font-weight: bold;
    font-size: 1.2rem;
    color:blue;
    margin-left: 20px;
    margin-top: 10px;
    margin-bottom: 10px;
}

.errorMessage{
    color:red;
    border: 2px solid red;
    padding: 10px;
}

.emp-clear-status{
    color:blue;
    border: 2px solid red;
    font-weight: bold;
    padding: 5px;
}
</style>